import React, { Component } from "react";
import { success, info, error, warning, clear } from "toastr";
// Redux
import { Link } from "react-router-dom";

import { Row, Col, Container, Label, Button } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import "./login-flow.css";
import { loginUserAPI } from "api";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: props.history,
    };
  }
  componentDidMount() {
    if (localStorage.getItem("authUser")) {
      // this.switchRoutes(JSON.parse(localStorage.getItem("authUser")).roleId);
    }
  }
  switchRoutes(roleId) {
    switch (roleId) {
      case "ROLE0000008":
        this.state.history.push("/add-purchased-item");
        // window.location.reload();
        break;
      case "ROLE0000007":
        this.state.history.push("/user-dashboard");
        window.location.reload();
        break;
      case "ROLE0000004":
        this.state.history.push("/machine-operator-dashboard");
        window.location.reload();
        break;
      case "ROLE0000003":
        this.state.history.push("/filler-dashboard");
        window.location.reload();
        break;
      case "ROLE0000002":
        this.state.history.push("/grader-dashboard");
        window.location.reload();
        break;
      case "ROLE0000001":
        this.state.history.push("/data-entry-dashboard");
        window.location.reload();
        break;
      default:
        this.state.history.push("/admin-dashboard");
        // window.location.reload();
    }
  }
  render() {
    document.title = "Login";
    return (
      <React.Fragment>
        <Container fluid className="main-login-flow">
          <Row className="px-lg-0 px-md-5 px-2">
            <Col xl={4} lg={12} className="offset-xl-2 mt-1">
              <div className="logo-main">
                <span className="login-flow-logo fs-2 px-4 fw-bold d-inline-block">
                  <img src="images/loginImage.jpg" alt="loginimage" className="width-100 rounded-circle" />
                </span>
              </div>

              <Formik
                enableReinitialize={true}
                initialValues={{
                  email: (this.state && this.state.email) || "",
                  password: (this.state && this.state.password) || "",
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string().required("Please Enter email"),
                  password: Yup.string().required("Please Enter your password"),
                })}
                onSubmit={async values => {
                  const data = await loginUserAPI(values);
                  console.log(data)
                  if (data && data.success) {
                    let user = localStorage.setItem("authUser", JSON.stringify(data.data));
                    success("ok", "Success", { timeOut: 5000 });
                    
                    setTimeout(() => {
                      console.log(data.data.id)
                      window.location.reload();
                      // this.switchRoutes(data.data.id.includes("ADMIN") ? 56 :data.data.roleId);
                    }, 1000);
                  } else {
                    error("Your email or password is incorrect");
                  }
                }}
              >
                {({ errors, status, touched }) => (
                  <Form>
                    <h1 className="text-primary-light fw-bold pt-md-5 login-flow-h1">
                      Log In
                    </h1>
                    <p className="login-flow-p pt-2 pb-2">
                      Enter your email and password to Log In
                    </p>
                    <div className="mt-2">
                      <Label
                        for="email"
                        className="form-label d-block pb-2 fw-bold login-flow-lable"
                      >
                        E-Mail
                      </Label>
                      <Field
                        name="email"
                        placeholder="Enter email"
                        type="email"
                        className={
                          "form-control py-1 py-md-3 fs-4" +
                          (errors.email && touched.email ? " is-invalid" : "")
                        }
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                    <div className="mt-2">
                      <Label
                        for="password"
                        className="form-label d-block pb-2 fw-bold login-flow-lable"
                      >
                        Password
                      </Label>
                      <Field
                        name="password"
                        placeholder="************"
                        type="password"
                        className={
                          "form-control py-1 py-md-3 fs-4" +
                          (errors.password && touched.password
                            ? " is-invalid"
                            : "")
                        }
                      />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                    {/* <Link
                      to="/pages-forgot-pwd"
                      className="text-light-primary fw-bold d-block text-lg-end fs-5"
                    >
                      Forgot password
                    </Link> */}
                    {/* <div className="mt-4">
                      <div className="form-check">
                        <Field
                          type="checkbox"
                          name="receiveEmail"
                          className="form-check-input"
                        />
                        <label className="form-check-label ps-3 pt-0 pt-sm-1 text-gray">
                          Yes, I want to receive emails
                        </label>
                      </div>
                    </div> */}
                    {/* <div className="mt-2">
                      <div className="form-check">
                        <Field
                          type="checkbox"
                          className="form-check-input"
                          name="agree"
                        />
                        <label className="form-check-label ps-3 pt-0 pt-sm-1 text-gray">
                          I agree to the
                          <span className="text-primary-light fw-bold">
                            Terms, Privacy Policy.
                          </span>
                        </label>
                      </div>
                    </div> */}
                    <div className="mt-0 mt-md-5">
                      <Button
                        className="w-100 text-white fw-bold fs-3 login-flow-btn mt-2"
                        type="submit"
                      >
                        LOG IN
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
            <Col
              xl={6}
              lg={12}
              className="text-center text-xl-start align-self-center"
            >
              <img
                src="images/loginFlow-images/login.svg"
                alt="login"
                className="w-md-100"
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Login;
